module.exports = __webpack_public_path__ + "img/zhouwei.df1f6b2a.png";